<div class="wrap">
  <swiper
    [slidesPerView]="1"
    [spaceBetween]="0"
    [loop]="true"
    [autoplay]="{ delay: 6000, disableOnInteraction: false }"
    [navigation]="true"
    [pagination]="{ clickable: true }"
  >
    <ng-template
      *ngFor="let photo of getCurrentSlides()"
      swiperSlide
    >
      <img
        [src]="photo"
        alt="photo"
        loading="lazy"
      /> </ng-template
  ></swiper>
</div>

<div class="wrap__time">
  <app-time></app-time>
</div>
